import { promisify } from "./_utils/promisify";
import { styleIn } from "./_utils/styleOptions";
export var normalize = {
  push: function push(api, containerName) {
    return function (options) {
      return promisify(api)(styleIn(options, containerName));
    };
  },
  back: function back(api, containerName) {
    return function (options) {
      return promisify(api)(styleIn(options, containerName));
    };
  },
  go: function go(api, containerName) {
    return function (options) {
      return promisify(api)(styleIn(options, containerName));
    };
  },
  replace: function replace(api, containerName) {
    return function (options) {
      return promisify(api)(styleIn(options, containerName));
    };
  },
  reLaunch: function reLaunch(api, containerName) {
    return function (options) {
      return promisify(api)(styleIn(options, containerName));
    };
  },
  switchTab: function switchTab(api, containerName) {
    return function (options) {
      return promisify(api)(styleIn(options, containerName));
    };
  }
};